module.exports = __webpack_public_path__ + "static/media/+.e45a8ff7.png";